import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { goodsManageListNewData} from './data'
import {setPageNewItem} from "@/utils";
import './index.scss'
import {message} from "antd";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {normaluserlist,normaluseredit} from "../../../../../servers/goodsManageApi";

@CBaseComponent
class StoreManageListNew extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }


  state = {
    data: goodsManageListNewData,
  }

  onChange(data){
    this.setState({
      data: setPageNewItem(this.state.data, data.data.id, 'value', data.value)
    })
  }

  getListData(){
    let getData = {
      id: ''
    };
    this.setState({
      loading: true
    });
    normaluserlist(getData).then(res=>{
      const result = []
      res.records[0].rightlist.forEach(item=>{
        result.push({
          name:item.name,
          value:item.id
        })
      })
      this.state.data[0].data[4].options = result
      this.setState({
        loading: false,
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  onCancel(){
    this.props.history.push({
      pathname: '/user'
    })
  }

  onSubmit(data){
    if (data.status) {
      const params = data.data
      params.rights = params.rights.join(',')
      if(this.getUrlParams(window.location.href).type === 'edit'){
        params.id = this.getUrlParams(window.location.href).id
      }
      if (this.getUrlParams(window.location.href).type !== 'edit' && params.password === '******') {
        message.error('密码不能为******');
        return
      }
      normaluseredit(params).then(res=>{
          if (res.statecode === 0) {
            if(this.getUrlParams(window.location.href).type === 'edit'){
              message.success('编辑成功');
            }
            else {
              message.success('添加成功');
            }
            this.props.history.push({
              pathname: '/user',
            })
          } else {
            if(this.getUrlParams(window.location.href).type === 'edit'){
              message.error(res.statemessage);
            }
            else {
              message.error(res.statemessage);
            }
          }
        }).catch(err=>{

        });
    }
  }
  getUrlParams(url) {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1]
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&')
    for(let i = 0,len = paramsArr.length;i < len;i++){
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
    return obj
  }


  componentWillMount(){
    this.getListData()
    if(this.getUrlParams(window.location.href).type === 'edit'){
      const p = this.state.data[0].data[1].checkType = ''
      this.setState({
        data:p
      })
      const params = JSON.parse(sessionStorage.getItem('userEdit'))
      const result = this.state.data
      result[0].data[0].value = params.realname
      result[0].data[1].value = params.password == 1 ? '******':''
      result[0].data[2].value = params.mobile
      result[0].data[3].value = params.email
      result[0].data[4].value = params.rights.split(',')
      this.setState({
        data:result
      })
    } else {
      const p = this.state.data[0].data[1].checkType = 'required'
      this.setState({
        data:p
      })
      const result = this.state.data
      result[0].data[0].value = ''
      result[0].data[1].value = ''
      result[0].data[2].value = ''
      result[0].data[3].value = ''
      result[0].data[4].value = []
      this.setState({
        data:result
      })
    }
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <CPageNew data={this.state.data}
                  onChange={this.onChange}
                  onSearch={this.onSearch}
                  onSubmit={this.onSubmit}
                  onCancel={this.onCancel}
        />
      </div>
    )
  }
}
export default compose(withRouter)(StoreManageListNew);
